module.exports = __webpack_public_path__ + "img/roulette-overlay2.d9696bee.png";